import { Header } from './Header';
import { Sidebar } from './Sidebar';

export function DashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 p-6 md:p-8 lg:p-12">
          {children}
        </main>
      </div>
    </div>
  );
}

export default DashboardLayout;
